import { updateObject } from '../../utility';

const initFormData = {
    password: {
        value: ''
    }
};
const initialState = {
    formData: initFormData,
    isSubmited: false
}

const setInit = (state) => {
    return updateObject(state, {formData: initFormData, isSubmited: false});
}

const inputChanged = (state, action) => {
    let identifier = action.payload.identifier;
    let value = action.payload.value;
    let formData = {...state.formData};
    formData[identifier] = {...formData[identifier], ...{value}};

    return updateObject(state, {formData, isSubmited: false});
}

const setIsSubmit = (state, action) => {
    return updateObject(state, {isSubmited: action.value});
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case 'RESET_PASSWORD_INIT': return setInit(state);
        case 'RESET_PASSWORD_INPUT_CHANGED': return inputChanged(state, action);
        case 'RESET_PASSWORD_SUBMIT_SUCCESS': return setIsSubmit(state, action);
        default: return state;
    }
};

export default reducer;